module.exports = __webpack_public_path__ + "static/golem-5fd056e5a6b5a691ff15040babce1077.jpg";